import React from "react";

const icons = {
  search: (
    <path d="M11 4a7 7 0 1 0 4.65 12.24l4.06 4.05a1 1 0 0 0 1.42-1.41l-4.06-4.06A7 7 0 0 0 11 4Zm0 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z" />
  ),
  play: <path d="M8 6.82v10.36a1 1 0 0 0 1.53.85l8.17-5.18a1 1 0 0 0 0-1.7L9.53 5.97A1 1 0 0 0 8 6.82Z" />,
  heart: (
    <path d="M12 20s-7.2-4.35-9.57-8.13C.57 8.9 2.05 5 5.5 5c2.09 0 3.2 1.2 3.96 2.18.76-.98 1.87-2.18 3.96-2.18C16.95 5 18.43 8.9 21.57 11.87 19.2 15.65 12 20 12 20Z" />
  ),
  heartOff: (
    <>
      <path d="M5.5 5c2.09 0 3.2 1.2 3.96 2.18.76-.98 1.87-2.18 3.96-2.18C16.95 5 18.43 8.9 21.57 11.87c-1.03 1.64-3.03 3.44-4.93 4.86l1.48 1.48a1 1 0 1 1-1.42 1.42L3.29 6.22A1 1 0 1 1 4.7 4.8l1.3 1.3c-.17-.05-.34-.1-.5-.1Zm-.96 4.3c-1.03 1.28-1.13 2.23-.39 3.14C6.52 16.22 12 20 12 20s1.6-.97 3.46-2.45L4.54 9.3Z" />
    </>
  ),
  star: <path d="m12 3.2 2.4 4.88 5.38.78-3.89 3.8.92 5.35L12 15.49 7.19 18l.92-5.35-3.89-3.8 5.38-.78L12 3.2Z" />,
  close: (
    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z" />
  ),
  grid: (
    <path d="M4 4h6v6H4V4Zm10 0h6v6h-6V4ZM4 14h6v6H4v-6Zm10 0h6v6h-6v-6Z" />
  ),
};

/**
 * Los íconos de uso frecuente viven en el mapa `icons`. Para un ícono puntual
 * que no amerite sumarse ahí, se puede pasar el path SVG como children sin
 * tener que tocar este archivo (abierto a extensión, cerrado a modificación).
 */
export default function Icon({ name, className = "", size = 18, children }) {
  const glyph = icons[name] ?? children ?? null;

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      {glyph}
    </svg>
  );
}
